import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FaceUnlockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"face_unlock"}/>
}
